import { create } from 'zustand';
import type { StorageEntityValue } from '../../../../../types/azureStorage';
import type { TableExplorerColumn } from '../../../core/types/workspaceTypes';
import type { LoadedEntitySort } from './entityViewState';

export type EntityTabRuntime = {
  columns: TableExplorerColumn[];
  rows: Record<string, unknown>[];
  propertyTypes: Record<string, StorageEntityValue['t']>;
  currentPage: number;
  loading: boolean;
  error?: string;
  sort?: LoadedEntitySort;
};

type EntityTabRuntimeState = {
  entries: Record<string, EntityTabRuntime>;
  publish: (tabId: string, runtime: EntityTabRuntime) => void;
  remove: (tabId: string) => void;
  clear: () => void;
};

export const useEntityTabRuntimeStore = create<EntityTabRuntimeState>((set) => ({
  entries: {},
  publish: (tabId, runtime) => set((state) => ({ entries: { ...state.entries, [tabId]: runtime } })),
  remove: (tabId) => set((state) => {
    const entries = { ...state.entries };
    delete entries[tabId];
    return { entries };
  }),
  clear: () => set({ entries: {} }),
}));
